import { LoadingPage } from '@act/storybook';
import { List, ListItem, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useAppNavigation } from 'react-components/app/routing/routes';
import { getNeedsMetadata } from 'redux/slices/metaSlice';
import { metaSliceSelectors } from 'redux/slices/metaSlice.hooks';
import { useAppDispatch } from 'redux/store-hooks';
import { LeftDrawer } from '../LeftDrawer';

export const NeedsContent = ({ children }: { children?: React.ReactNode }) => {
  const [selectedKey, setSelectedKey] = useState<string | null>(null);
  const needs = metaSliceSelectors.useSelectNeedsMetadata()?.data;
  const dispatch = useAppDispatch();
  useEffect(() => {
    if (!needs) {
      dispatch(getNeedsMetadata({}));
    }
  }, []);
  const navigate = useAppNavigation();

  if (!needs) {
    return <LoadingPage />;
  }

  const drawerContent = (
    <List sx={{ display: 'flex', flexDirection: 'column', gap: '8px', mt: 2 }}>
      {needs &&
        Object.keys(needs)?.map((key, index) => (
          <ListItem
            key={index}
            sx={{
              display: 'flex',
              flexDirection: 'row',
              gap: '16px',
              wordWrap: 'none',
              backgroundColor:
                selectedKey === key ? 'rgba(0, 0, 0, 0.04)' : 'transparent',
              '&:hover': {
                cursor: 'pointer',
                backgroundColor: 'rgba(0, 0, 0, 0.04)',
              },
            }}
            onClick={() => {
              setSelectedKey(key);
              navigate.toNeedsCategory(key);
            }}
          >
            <Typography>
              {key.charAt(0).toUpperCase() + key.slice(1)}
            </Typography>
          </ListItem>
        ))}
    </List>
  );
  return <LeftDrawer drawerContent={drawerContent}>{children}</LeftDrawer>;
};
